import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/Dashboard' ,
    name: 'dashboard' ,
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/Login' ,
    name: 'login' ,
    component: () => import('../views/Login.vue')
  },
  {
    path: '/NotAuthorized',
    name: 'not-authorized',
    component: () => import('../views/NotAuthorized.vue')
  },
  {
    path: '/ForgotPassword',
    name: 'forgot-password',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/ResetPassword',
    name: 'reset-password',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/Users/List',
    name: 'users-list',
    component: () => import('../views/users/UserList.vue'),
    meta: {
      requiresSystemAdministrator: true
    }
  },
  {
    path: '/Users/New',
    name: 'users-new',
    component: () => import('../views/users/UserNew.vue'),
    meta: {
      requiresSystemAdministrator: true
    }
  },
  {
    path: '/Users/Edit/:id',
    name: 'users-edit',
    component: () => import('../views/users/UserEdit.vue'),
    meta: {
      requiresSystemAdministrator: true
    }
  },
  {
    path: '/admin/MetroVan' ,
    name: 'metrovan-list' ,
    component: () => import('../views/admin/MetroVanGroupList.vue') ,
    meta: {
      requiresSystemAdministrator:  true
    }
  },
  {
    path: '/admin/MetroVanGroupEdit/:id',
    name: 'metrovan-edit' ,
    component: () => import( '../views/admin/MetroVanGroupEdit.vue' ) ,
    meta: {
      requiresSystemAdministrator: true
    }
  },
  {
    path: '/admin/Municipality' ,
    name: 'municipality-list' ,
    component: () => import('../views/admin/MunicipalityList.vue') ,
    meta: {
      requiresSystemAdministrator:  true
    }
  },
  {
    path: '/admin/MunicipalityEdit/:id',
    name: 'municipality-edit' ,
    component: () => import( '../views/admin/MunicipalityEdit.vue' ) ,
    meta: {
      requiresSystemAdministrator: true
    }
  },
  {
    path: '/admin/MunicipalityNew',
    name: 'municipality-new' ,
    component: () => import( '../views/admin/MunicipalityNew.vue' ),
    meta: {
      requiresSystemAdministrator:  true
    }
  },
  {
    path: '/Amendments/List',
    name: 'amendments-list',
    component: () => import('../views/amendments/AmendmentList.vue')
  },
  {
    path: '/Amendments/Details/:id',
    name: 'amendments-detail',
    component: () => import('../views/amendments/AmendmentDetail.vue')
  },
  {
    path: '/Amendments/Admin/:id',
    name: 'amendments-admin',
    component: () => import('../views/amendments/AmendmentAdmin.vue'),
    meta: {
      requiresMetroVanAmendmentEditor: true
    }
  },
  {
    path: '/Amendments/Edit/:id',
    name: 'amendments-edit',
    component: () => import('../views/amendments/AmendmentEdit.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Amendments/New',
    name: 'amendments-new',
    component: () => import('../views/amendments/AmendmentNew.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Amendments/Documents/:id',
    name: 'amendments-documents',
    component: () => import('../views/amendments/AmendmentDocuments.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Connections/List',
    name: 'connections-list',
    component: () => import('../views/connections/ConnectionList.vue')
  },
  {
    path: '/Connections/Details/:id',
    name: 'connections-detail',
    component: () => import('../views/connections/ConnectionDetail.vue')
  },
  {
    path: '/Connections/New',
    name: 'connections-new',
    component: () => import('../views/connections/ConnectionNew.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Extensions/List',
    name: 'extensions-list',
    component: () => import('../views/extensions/ExtensionList.vue')
  },
  {
    path: '/Extensions/Details/:id',
    name: 'extensions-detail',
    component: () => import('../views/extensions/ExtensionDetail.vue')
  },
  {
    path: '/Extensions/Admin/:id' ,
    name: 'extensions-admin',
    component: () => import('../views/extensions/ExtensionAdmin.vue'),
    meta: {
      requiresMetroVanExtensionEditor: true
    }
  },
  {
    path: '/Extensions/Edit/:id',
    name: 'extensions-edit',
    component: () => import('../views/extensions/ExtensionEdit.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Extensions/New',
    name: 'extensions-new',
    component: () => import('../views/extensions/ExtensionNew.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  },
  {
    path: '/Extensions/Documents/:id',
    name: 'extensions-documents',
    component: () => import('../views/extensions/ExtensionDocuments.vue'),
    meta: {
      requiresMunicipalUser: true
    }
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  // scrollBehavior: function (to, from, savedPosition) {
  //
  // },
  routes
})

router.beforeResolve((to, from, next) => {
  if ( to.matched.some( (record:any) => record.meta.requiresMetroVanAmendmentEditor ) && ( !store.getters.isMetroVanAmendmentEditor ) ) {
    next( { name: 'not-authorized'} )
  }
  else if ( to.matched.some( (record:any) => record.meta.requiresMetroVanExtensionEditor ) && ( !store.getters.isMetroVanExtensionEditor ) ) {
    next( { name: 'not-authorized' } )
  }
  else if ( to.matched.some( (record:any) => record.meta.requiresMunicipalUser) && (!store.getters.isMunicipalUser ) ) {
    next( { name: 'not-authorized' } )
  }
  else if ( to.matched.some( (record:any) => record.meta.requiresSystemAdministrator ) && ( !store.getters.isSystemAdministrator ) ) {
    next( { name: 'not-authorized' } )
  }
  else {
    next()
  }
})

export default router
